import classNames from "classnames";
import { useSidebar } from "../../hooks";
export const MobileNavContainer = ({ children }) => {
    const { active } = useSidebar();
    return (<div className={classNames("fixed inset-0 z-20 grid h-screen w-screen grid-cols-12 overflow-hidden overscroll-y-none bg-transparent duration-300 ease-linear lg:hidden", active ? "opacity-1" : "-translate-x-3/2 opacity-0")}>
            {children}
        </div>);
};
